/**
 * Created by Paul on 6/8/2017.
 */
import {Component, EventEmitter, Output} from "@angular/core";

@Component({
  selector: 'sm-popup',
  templateUrl: './sixMarkPopup.html',
  styleUrls: [ '/sixMarkPopup.scss' ]
})

export class SixMarkPopup {
  _IMG_FOLDER_LOTTERY_PATH: string = 'build/assets/images/lottery';
  // The meta data of popup
  popupData = {
    coins: [
      {
        imgName: 'casino1.png',
        amount: 1
      },
      {
        imgName: 'casino5.png',
        amount: 5
      },
      {
        imgName: 'casino10.png',
        amount: 10
      },
      {
        imgName: 'casino1k.png',
        amount: 1000
      },
      {
        imgName: 'casino2k.png',
        amount: 2000
      },
      {
        imgName: 'casino5k.png',
        amount: 5000
      },
      {
        imgName: 'casino10k.png',
        amount: 10000
      },
      {
        imgName: 'casino20k.png',
        amount: 20000
      },
      {
        imgName: 'casino50k.png',
        amount: 50000
      }
    ],
    menuItems: [
      {
        imgName: 'close.png',
        type: 'close'
      },
      {
        imgName: 'clear.png',
        type: 'clear'
      },
      {
        imgName: 'back.png',
        type: 'back'
      }
    ]
  };
  // Enum menu item type
  menuItemType = {
    close: 'close',
    clear: 'clear',
    back: 'back'
  };

  @Output() onCoinSelected: EventEmitter<any> = new EventEmitter();
  @Output() onCloseClicked: EventEmitter<any> = new EventEmitter();
  @Output() onClearClicked: EventEmitter<any> = new EventEmitter();
  @Output() onBackClicked: EventEmitter<any> = new EventEmitter();

  /**
   * Select a coin
   * @param selectedCoin
   */
  selectCoin(selectedCoin: number) {
    this.onCoinSelected.emit(selectedCoin);
  }

  /**
   * Select a menu item
   * @param menuItemType: the type of menu item
   */
  selectMenuItem(menuItemType: string) {
    switch (menuItemType) {
      case this.menuItemType.close: {
        this.onCloseClicked.emit();
        break;
      }
      case this.menuItemType.clear: {
        this.onClearClicked.emit();
        break;
      }
      case this.menuItemType.back: {
        this.onBackClicked.emit();
        break;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/sixMarkPopup/sixMarkPopup.ts